// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../layout-and-structure/Box.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Hover from "../../primitives/Hover.res.js";
import * as React from "react";
import * as Button from "../actions/Button.res.js";
import * as Inline from "../layout-and-structure/Inline.res.js";
import * as Popover from "../overlays/Popover.res.js";
import * as TextStyle from "../typography/TextStyle.res.js";
import * as Touchable from "../../primitives/Touchable.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as OverlayTriggerView from "../overlays/OverlayTriggerView.res.js";
import * as DayPickerSingleFastNav from "./DayPickerSingleFastNav.res.js";

function InputDateFieldFastNav(props) {
  let __grow = props.grow;
  let onRequestClear = props.onRequestClear;
  let onChange = props.onChange;
  let value = props.value;
  let __disabledFutureDays = props.disabledFutureDays;
  let __required = props.required;
  let required = __required !== undefined ? __required : false;
  let disabledFutureDays = __disabledFutureDays !== undefined ? __disabledFutureDays : false;
  let grow = __grow !== undefined ? __grow : false;
  let match = Popover.useTrigger(undefined, undefined, undefined);
  let popoverTriggerRef = match.ref;
  let popoverAriaProps = match.ariaProps;
  let popover = match.state;
  let match$1 = Hover.use(popoverTriggerRef, undefined, undefined);
  let match$2 = React.useState(() => false);
  let setFocused = match$2[1];
  React.useEffect(() => {
    setFocused(param => popover.isOpen);
  }, [popover.isOpen]);
  let onChange$1 = value => {
    onChange(value);
    popover.toggle();
  };
  let isDayBlocked = day => {
    let day$1 = new Date(day.getTime());
    let now = new Date();
    day$1.setHours(0);
    day$1.setMinutes(0);
    now.setHours(0);
    now.setMinutes(0);
    if (disabledFutureDays) {
      return day$1.getTime() > now.getTime();
    } else {
      return false;
    }
  };
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(Touchable.make, {
        children: JsxRuntime.jsx(OverlayTriggerView.make, {
          children: value !== undefined ? JsxRuntime.jsx(TextStyle.make, {
              children: I18n.dateTimeFormat(undefined, "long", undefined, undefined, undefined, undefined, undefined, undefined, undefined, value)
            }) : JsxRuntime.jsx(TextStyle.make, {
              children: I18n.t("Select a date"),
              variation: "normal"
            }),
          preset: {
            NAME: "inputField",
            VAL: {
              required: required,
              errorMessage: props.errorMessage
            }
          },
          label: props.label,
          icon: "calendar",
          hovered: match$1[1],
          active: popover.isOpen,
          focused: match$2[0]
        }),
        ariaProps: popoverAriaProps.triggerProps,
        grow: grow,
        onPress: param => popover.toggle(),
        ref: popoverTriggerRef
      }),
      popover.isOpen ? JsxRuntime.jsx(Popover.make, {
          children: JsxRuntime.jsxs(Popover.Dialog.make, {
            children: [
              JsxRuntime.jsx(DayPickerSingleFastNav.make, {
                value: value,
                onChange: onChange$1,
                isDayBlocked: isDayBlocked
              }),
              onRequestClear !== undefined && value !== undefined ? JsxRuntime.jsx(Box.make, {
                  children: JsxRuntime.jsx(Inline.make, {
                    children: JsxRuntime.jsx(Button.make, {
                      label: I18n.t("Clear"),
                      size: "small",
                      onPress: () => {
                        onRequestClear();
                        popover.close();
                      }
                    }),
                    align: "end"
                  }),
                  spaceX: "medium",
                  spaceBottom: "medium"
                }) : null
            ],
            ariaProps: popoverAriaProps.overlayProps,
            style: {
              maxWidth: "316px",
              minHeight: "300px"
            }
          }),
          triggerRef: popoverTriggerRef,
          state: {
            isOpen: popover.isOpen,
            close: popover.close,
            toggle: popover.toggle
          },
          placement: "bottom start",
          modal: false
        }) : null
    ]
  });
}

let make = React.memo(InputDateFieldFastNav);

export {
  make,
}
/* make Not a pure module */
